import { fabric } from 'fabric';


export function checkiffilterispresentfabric(fabricimagefilterarray, filternametoc, whichonesc) {
    for (let i = 0; i < fabricimagefilterarray.length; i++) {
        if (fabricimagefilterarray[i].type === filternametoc && filternametoc !== "Convolute") {
            return i;
        } else if (fabricimagefilterarray[i].type === filternametoc && filternametoc === "Convolute") {
            var m1 = [ 0, -1,  0, -1, 5, -1, 0, -1, 0];
            var m2 = [ 1, 1, 1, 1, 0.7, -1, -1,  -1, -1 ];
            if (JSON.stringify(fabricimagefilterarray[i].matrix) == JSON.stringify(m1) && whichonesc == 1) {
                 return i;
            } else if (JSON.stringify(fabricimagefilterarray[i].matrix) == JSON.stringify(m2) && whichonesc == 2) {
                return i;
            }
        }
    }
    return -1;
}

export default checkiffilterispresentfabric;